(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeDialogController', CompanyTypeDialogController);

    CompanyTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyType'];

    function CompanyTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyType) {
        var vm = this;
        vm.companyType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:companyTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.companyType.id !== null) {
                CompanyType.update(vm.companyType, onSaveSuccess, onSaveError);
            } else {
                CompanyType.save(vm.companyType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
